import FavoriteProductsCounter from './root.vue';
import '../../../vuex_modules/favorite_products';

const elements = document.querySelectorAll(
  '.vue-favorite-products-counter-mobile'
);

function mountComponent(el, selector) {
  new Vue({
    el,
    store: vuexStore,
    render: (h) =>
      h(FavoriteProductsCounter, {
        props: {initCount: el.innerText.trim(), counterSelector: selector},
      }),
  });
}

elements.forEach((el) => {
  const classModifier = el.dataset.classModifier;

  if (classModifier) {
    mountComponent(el, classModifier);
    return;
  }
  mountComponent(el, 'favorite-products-counter__content');
});
